"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExpectedReceived = exports.ExpectedNumberOfCalls = exports.Expected = exports.Diff = void 0;

var _react = _interopRequireDefault(require("react"));

var _tsDedent = _interopRequireDefault(require("ts-dedent"));

var _theming = require("@storybook/theming");

var _MatcherResult = require("./MatcherResult");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledWrapper = _theming.styled.div(({
  theme
}) => ({
  backgroundColor: theme.background.content,
  padding: '12px 0',
  boxShadow: `0 0 0 1px ${theme.appBorderColor}`,
  color: theme.color.defaultText,
  fontSize: 13
}));

var _default = {
  title: 'Addons/Interactions/MatcherResult',
  component: _MatcherResult.MatcherResult,
  decorators: [Story => /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(Story, null))],
  parameters: {
    layout: 'fullscreen'
  }
};
exports.default = _default;
const Expected = {
  args: {
    message: (0, _tsDedent.default)`
      expect(jest.fn()).lastCalledWith(...expected)

      Expected: {"email": "michael@chromatic.com", "password": "testpasswordthatwontfail"}

      Number of calls: 0
    `
  }
};
exports.Expected = Expected;
const ExpectedReceived = {
  args: {
    message: (0, _tsDedent.default)`
      expect(jest.fn()).toHaveBeenCalledWith(...expected)

      Expected: called with 0 arguments
      Received: {"email": "michael@chromatic.com", "password": "testpasswordthatwontfail"}

      Number of calls: 1
    `
  }
};
exports.ExpectedReceived = ExpectedReceived;
const ExpectedNumberOfCalls = {
  args: {
    message: (0, _tsDedent.default)`
      expect(jest.fn()).toHaveBeenCalledTimes(expected)

      Expected number of calls: 1
      Received number of calls: 0
    `
  }
};
exports.ExpectedNumberOfCalls = ExpectedNumberOfCalls;
const Diff = {
  args: {
    message: (0, _tsDedent.default)`
      expect(jest.fn()).toHaveBeenCalledWith(...expected)

      - Expected
      + Received

        Object {
      -   "email": "michael@chromatic.com",
      +   "email": "michael@chromaui.com",
          "password": "testpasswordthatwontfail",
        },

      Number of calls: 1
    `
  }
};
exports.Diff = Diff;